import React from 'react';
import featureNew1 from "../../assets/img/feature-new-1.svg";
import featureNew2 from "../../assets/img/feature-new-2.svg";


const FeatureSection = () => {
    return (
        <div className="feature-section ptb-100">
            <div className="container">
                {/* First Row */}
                <div className="row align-items-center justify-content-between">
                    <div className="col-md-7 col-lg-5">
                        <div className="feature-content-wrap">
                            <h2>99% Cloud Hosing High-speed Cutting-edge Platform</h2>
                            <p>
                                Compellingly customize maintainable results with client-based applications. Dynamically fabricate B2C intellectual capital paradigms. Authoritatively strategize customer directed web-readiness vis-a-vis an expanded array of relationships.
                            </p>
                            <p>
                                Globally synergize team driven testing procedures through end-to-end e-commerce. Uniquely grow backward-compatible deliverables whereas diverse customer service. Credibly communicate vertical synergy without top-line services.
                            </p>
                            <a href="about-us.html" className="read-more-link">
                                Know more about us <i className="fas fa-arrow-right ms-2"></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-5 col-lg-6 d-none d-md-block d-lg-block">
                        <div className="feature-img-wrap text-center">
                            <img src={featureNew1} className="img-fluid" alt="server room"  />

                        </div>
                    </div>
                </div>

                {/* Second Row */}
                <div className="row align-items-center justify-content-between mt-5">
                    <div className="col-md-5 col-lg-6 d-none d-md-block d-lg-block">
                        <div className="feature-img-wrap text-center">
                            <img src={featureNew2} className="img-fluid" alt="server room"  />
                        </div>
                    </div>
                    <div className="col-md-7 col-lg-5">
                        <div className="feature-content-wrap">
                            <h2>Our Own Interfaces for All Management Processes</h2>
                            <p>
                                Authoritatively transform functionalized information without cross-platform convergence. Quickly cross-unit e-markets without superior products foster timely collaboration and idea-sharing rather than magnetic potentialities restore high standards in outsourcing whereas vertical meta-services. Compellingly reconceptualize out-of-the-box outsourcing through plug-and-play synergy.
                            </p>
                            <a href="about-us.html" className="read-more-link">
                                Know more about us <i className="fas fa-arrow-right ms-2"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureSection;
